import React, { useEffect, useState } from 'react'
import logo from '../../images/ng_logo.png'
import { NavLink, useLocation } from 'react-router-dom'
import DensityMediumIcon from '@mui/icons-material/DensityMedium'
import CancelIcon from '@mui/icons-material/Cancel'
import LanguageSelector from '../../component/LanguageSelector'
import NavBarSticky from './NavBarSticky'
import { FiChevronDown, FiChevronUp } from 'react-icons/fi'

export default function NavBar(props) {
  const location = useLocation()
  const [openSub, setOpenSub] = useState('')
  const [openNav, setOpenNav] = useState(false)
  const [scrollChaNav, setScrollChaNav] = useState(false)

  useEffect(() => {
    if (openNav) {
      document.body.style.overflowY = "hidden";
    } else {
      document.body.style.overflowY = "auto";
    }
  }, [openNav]);

  const handleNav = () => {
    setOpenNav(!openNav);
  };

  const handleSub = (name) => {
    if (name === openSub) {
      setOpenSub("");
    } else {
      setOpenSub(name);
    }
  }

  const changeNavBar = () => {
    if (window.scrollY >= 490) {
      setScrollChaNav(true)
    } else {
      setScrollChaNav(false)
    }
  }
  useEffect(() => {
    window.addEventListener('scroll', changeNavBar)
    return () => {
      window.removeEventListener('scroll', changeNavBar)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      {!location.pathname.includes("career") ? (
          <div className={`navbar-container${scrollChaNav ? ' scrolled' : ''}`}>
          <nav>
            <a className="ngEagleLogo" href="/">
              <img src={logo} alt="NG logo" />
            </a>

            <div className="desktop-view">
              {scrollChaNav ? <NavBarSticky /> :

                (
                  <>
                    <div className="border-bottom">
                      <ul>
                        <li>
                          <NavLink to="/" className={({ isActive }) => isActive ? 'active' : ''}>Home</NavLink>
                        </li>
                        <li>
                          <NavLink to="/about_us" className={({ isActive }) => isActive ? 'active' : ''}>About</NavLink>
                        </li>
                        <li className="menu text-nowrap">
                          <a href={true} className="cursor-pointer">Travel info</a>
                          <div className="menu-sub row">
                            <div className="col-3 border-end">
                              <img src={logo} alt="" />
                            </div>
                            <div className="col-9 pt-5">
                              <div className="row">
                                <div className="col-4 sub_details">
                                  <ul>
                                    <li>
                                      <NavLink to="/baggage_policy">Baggage Policy</NavLink>
                                    </li>
                                    <li>
                                      <NavLink to="/refund_policy">
                                        Refund Policy
                                      </NavLink>
                                    </li>
                                    <li>
                                      <NavLink to="#">
                                        Fare Rules
                                      </NavLink>
                                    </li>
                                  </ul>
                                </div>
                                <div className="col-4 sub_details">
                                  <ul>
                                    <li>
                                      <NavLink to="#">
                                        Dangerous Goods Notice
                                      </NavLink>
                                    </li>
                                    <li>
                                      <NavLink to="/terms_and_condition">
                                        Term and Condition
                                      </NavLink>
                                    </li>
                                    <li>
                                      <NavLink to="/privacy_policy">
                                        Privacy Notice
                                      </NavLink>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>
                        <li className="menu text-nowrap">
                          <a href={true} className="cursor-pointer">Booking</a>
                          <div className="menu-sub row">
                            <div className="col-3 border-end">
                              <img src={logo} alt="" />
                            </div>
                            <div className="col-9 pt-5">
                              <div className="row">
                                <div className="col-4 sub_details">
                                  <ul>
                                    <li>
                                      <NavLink to="/group_booking">Group</NavLink>
                                    </li>
                                    <li>
                                      <NavLink to="/charter_sales">
                                        Charter
                                      </NavLink>
                                    </li>
                                    <li>
                                      <NavLink to="/corporate_sales">
                                        Corporate
                                      </NavLink>
                                    </li>
                                  </ul>
                                </div>
                                  <div className="col-4 sub_details">
                                    <ul>
                                      <li>
                                        <NavLink to="/cargo_sales">
                                          Cargo
                                        </NavLink>
                                      </li>
                                      <li>
                                        <NavLink to="/travel_agent_sale">
                                          Travel Agent
                                        </NavLink>
                                      </li>
                                    </ul>
                                  </div>
                                  <div className="col-4 sub_details">
                                    <ul>
                                      <li>
                                        <NavLink to="/military_fare">
                                          Military Fare
                                        </NavLink>
                                      </li>
                                      <li>
                                        <NavLink to="/nysc_fares">
                                          NYSC Fares
                                        </NavLink>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </li>
                          <li>
                          <NavLink to="/career" className={({ isActive }) => isActive ? 'active' : ''}>Career</NavLink>
                        </li>
                        <li>
                          <NavLink to="/contact_us" className={({ isActive }) => isActive ? 'active' : ''}>Contact</NavLink>
                        </li>
                      </ul>

                      <div className="buttons-div text-nowrap">
                        <button className="signup btn">Sign up</button>
                        <button className="login_button btn">Login</button>
                      </div>
                    </div>

                    <LanguageSelector />
                  </>
                )
              }
            </div>

            <div className="mobile-icon cursor-pointer" onClick={handleNav}>
              <DensityMediumIcon fontSize="large" />
            </div>

            <div className={`mobile-view${openNav ? ' open' : ''}`}>
              <div className="foorcveNav mb-4">
                <div className="d-flex justify-content-between foorcveNavM">
                  <div className=""><img src={logo} alt="NG logo" /></div>
                  <div className="foorcveNavIcon cursor-pointer">
                    <CancelIcon fontSize="large" onClick={handleNav} />
                  </div>
                </div>
              </div>
              <ul>
                <li>
                  <div className="hhhjjueiwe">
                    <NavLink to="/" className={({ isActive }) => isActive ? 'active' : ''}>Home</NavLink>
                  </div>
                </li>
                <li>
                  <div className="hhhjjueiwe">
                    <NavLink to="/about_us" className={({ isActive }) => isActive ? 'active' : ''}>About Us</NavLink>
                  </div>
                </li>
                <li>
                  <div>
                    <a
                      href={true}
                      onClick={() => handleSub("travel")}
                      className="w-100 d-flex justify-content-between align-items-center"
                    >
                      <span>Travel info</span>
                      {openSub === "travel" ? (
                        <FiChevronUp />
                      ) : (
                        <FiChevronDown />
                      )}
                    </a>
                    {openSub === "travel" ? (
                      <ul className="sub_links">
                        <li>
                          <NavLink to="/baggage_policy" className={({ isActive }) => isActive ? 'active' : ''}>
                            Baggage Policy
                          </NavLink>
                        </li>
                        <li>
                          <NavLink to="/refund_policy" className={({ isActive }) => isActive ? 'active' : ''}>Refund Policy</NavLink>
                        </li>
                        <li>
                          <NavLink to="#" className={({ isActive }) => isActive ? 'active' : ''}>
                            Fare Rules
                          </NavLink>
                        </li>
                        <li>
                          <NavLink to="#" className={({ isActive }) => isActive ? 'active' : ''}>
                            Dangerous Goods Notice
                          </NavLink>
                        </li>
                        <li>
                          <NavLink to="/terms_and_condition" className={({ isActive }) => isActive ? 'active' : ''}>Term and Condition</NavLink>
                        </li>
                        <li>
                          <NavLink to="/privacy_policy" className={({ isActive }) => isActive ? 'active' : ''}>Privacy Notice</NavLink>
                        </li>
                      </ul>
                    ) : null}
                  </div>
                </li>

                <li>
                  <div>
                    <a
                      href={true}
                      onClick={() => handleSub("miles")}
                      className="w-100 d-flex justify-content-between align-items-center"
                    >
                      <span>Booking</span>
                      {openSub === "miles" ? (
                        <FiChevronUp />
                      ) : (
                        <FiChevronDown />
                      )}
                    </a>
                    {openSub === "miles" ? (
                      <ul className="sub_links">
                        <li>
                          <NavLink to="/group_booking" className={({ isActive }) => isActive ? 'active' : ''}>Group</NavLink>
                        </li>
                        <li>
                          <NavLink to="/charter_sales" className={({ isActive }) => isActive ? 'active' : ''}>
                            Charter
                          </NavLink>
                        </li>
                        <li>
                          <NavLink to="/corporate_sales" className={({ isActive }) => isActive ? 'active' : ''}>Corporate</NavLink>
                        </li>
                        <li>
                          <NavLink to="/cargo_sales" className={({ isActive }) => isActive ? 'active' : ''}>Cargo</NavLink>
                        </li>
                        <li>
                          <NavLink to="/travel_agent_sale" className={({ isActive }) => isActive ? 'active' : ''}>
                            Travel Agent
                          </NavLink>
                        </li>
                        <li>
                          <NavLink to="/military_fare" className={({ isActive }) => isActive ? 'active' : ''}>
                            Military Fare
                          </NavLink>
                        </li>
                        <li>
                          <NavLink to="/nysc_fares" className={({ isActive }) => isActive ? 'active' : ''}>
                            NYSC Fares
                          </NavLink>
                        </li>
                      </ul>
                    ) : null}
                  </div>
                </li>
                <li>
                  <div className="hhhjjueiwe">
                    <NavLink to="/contact_us" className={({ isActive }) => isActive ? 'active' : ''}>Contact Us</NavLink>
                  </div>
                </li>
              </ul>

              <div className="buttons-div">
                <button className="login_button btn">Login</button>
                <button className="signup btn">Sign up</button>
                <LanguageSelector />
              </div>
            </div>


          </nav>
        </div>
      ) : null}
    </>
  );
}
